import { InputRadioComponent } from './input-radio/input-radio.component';

export const FORM_INPUT_COMPONENTS = [InputRadioComponent];
